import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import {
  ENV,
  MEKIDOC_GA4_TRACKING_ID,
  MEKIDOC_GOOGLE_ADS_ID,
  SENTRY_DSN,
} from "./environment";
import ReactGA from "react-ga4";
import { installChunkErrorReloader } from "./utils/chunkErrorReloader";

installChunkErrorReloader();

if (ENV === "production") {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/mekidoc\.cl/],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring:
    //  Capture 100% of the transactions
    tracesSampleRate: 1.0,
    // Session Replay:
    // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.1,
    // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 1.0,
  });

  // Initialize Google Analytics 4
  ReactGA.initialize(MEKIDOC_GA4_TRACKING_ID);
  // Associate it with Google Ads
  ReactGA.gtag("config", MEKIDOC_GOOGLE_ADS_ID);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
